export default "__VITE_ASSET__Bow21KJb__"